import { isNil } from 'lodash';
import { apiDataResponseMapper } from '../utils';
import type {
  Feature,
  FeatureList,
  FeatureListResponseData,
  FeatureResponseData,
  FeatureInfoResponse,
  FeatureInfo,
  UpdateFeatureInfoPayload,
} from './types';

export const featureListResponseMapper = (
  featureListResponse: FeatureListResponseData,
): FeatureList => {
  const featureList: FeatureList = { features: [] };

  featureList.features = featureListResponse.features.map(
    (featureResponse: FeatureResponseData) => {
      return apiDataResponseMapper<FeatureResponseData, Feature>(
        featureResponse,
      );
    },
  );
  return featureList;
};

export const featureInfoResponseMapper = (
  featureInfoResponse: FeatureInfoResponse,
): FeatureInfo => {
  const { attributes, ...rest } = featureInfoResponse;

  const response = apiDataResponseMapper<
    Omit<FeatureInfoResponse, 'attributes'>,
    FeatureInfo
  >(rest);

  response.iterationId = response.iterationId ?? null;
  response.attributes = attributes;

  return response;
};

export const featureInfoPayloadMapper = (payload: UpdateFeatureInfoPayload) => {
  const { id, info, images } = payload;
  const formDataPayload = new FormData();

  formDataPayload.append('id', id);

  if (images) {
    images.forEach((value) => {
      if (!isNil(value)) {
        formDataPayload.append('image_list', value, value.name);
      }
    });
  }

  formDataPayload.append('info', info ?? '');

  return formDataPayload;
};
